import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pg',
  templateUrl: './pg.component.html',
  styleUrls: ['./pg.component.scss']
})
export class PgComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
